<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/bank/paymentOption")
          i.fas.fa-money-bill-alt
          span.ml-1 {{ $t("ui.payment_option") }}
  div.row
    div.col-md-12
      div.card
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 60%;")
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.payment_mode')") {{ $t('ui.payment_mode') }}
                      th.sticky-position(width="35%")
                        span(:title="$t('ui.payment_desc')") {{ $t("ui.payment_desc") }}
                      th.sticky-position.text-center(width="7%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      th.sticky-position.text-center(width="10%")
                        span {{ $t('ui.sequence') }}
                      th.text-center.sticky-position(width="15%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="paymentOptionList.length == 0")
                      td(colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in paymentOptionList")
                      td
                        span(:title="index + 1") {{ index + 1 }}
                      td
                        span(:title="item.payment_mode") {{ item.payment_mode }}
                      td
                        span(:title="item.payment_desc") {{ item.payment_desc }}
                      td.text-center
                        div.d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="item.status" @change="changedStatus(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                      td.text-center
                        select(
                          :value="item.seq"
                          size="md"
                          @change="changedSeq(item, $event)"
                          )
                          option(value=0 disabled) 0
                          option(v-for="index in paymentOptionList.length" :key="index") {{ index }}
                      td.actions
                        span
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit_provider')")
    editpaymentoptionprovider(ref="editpaymentoptionprovider" :item="editSelectedPaymentMode" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editpaymentoptionprovider from "@/components/bank/editPaymentOptionProvider.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editpaymentoptionprovider
  },
  data: () => ({
    loading: false,
    paymentOptionList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedPaymentMode: null,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  mounted: function() {
    this.getPaymentOptionList();
  },
  methods: {
    changedSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_payment_mode_seq_confirm", { mode: item.payment_mode }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSeq(item, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = item.seq;
          }
        });
    },
    confirmSeq: function(item, seq) {
      let url = config.paymentOptionUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: item.payment_mode,
        seq: seq,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPaymentOptionList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "edit_payment_option_provider", this.feedback.status);
                // this.$refs.editPaymentOptionProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onEdit(e) {
      this.editSelectedPaymentMode = e;
      this.$refs.editpaymentoptionprovider.$refs.editPaymentOptionProvider.show();
    },
    afterEdit: function(item) {
      this.getPaymentOptionList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider"), this.$t("message.success"), "success");
    },
    getPaymentOptionList: function() {
      let url = config.paymentOptionListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.paymentOptionList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_payment_mode_status_confirm", { name: item.payment_mode }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.paymentOptionUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        payment_mode: item.payment_mode,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getPaymentOptionList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
